// The side column of widgets beside a content calendar, a pipeline or a sheet (Round 7, 21 Oct): how it stands.
// The board keeps when the user tucked it away (Board.shelfHidden); a widget added since brings it back, so a widget
// the user or an agent adds is never out of sight.

import type { Board, WidgetItem } from "./types";

/** No widgets (no column), the column shown, or tucked away to a slim edge. */
export type ShelfState = "none" | "shown" | "tucked";

/** How the column stands: tucked away only while no widget has arrived since the user tucked it. */
export function shelfState(board: Pick<Board, "shelfHidden">, widgets: readonly Pick<WidgetItem, "createdAt">[]): ShelfState {
  if (!widgets.length) return "none";
  const newest = Math.max(...widgets.map((w) => w.createdAt || 0));
  return board.shelfHidden && board.shelfHidden >= newest ? "tucked" : "shown";
}
